import { render, staticRenderFns } from "./AreYouSure.vue?vue&type=template&id=0202c1c1"
import script from "./AreYouSure.vue?vue&type=script&lang=js"
export * from "./AreYouSure.vue?vue&type=script&lang=js"
import style0 from "./AreYouSure.vue?vue&type=style&index=0&id=0202c1c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports